export default [
  {
    name: 'Free',
    features: ['All our standard features', 'Up to 10 projects', 'Up to 15 users'],
  },
  {
    name: 'Starter',
    features: [
      'All our standard features',
      'Up to 100 projects',
      'Up to 15 users',
      'No everviz attribution',
      'Email support',
    ],
  },
  {
    name: 'Business',
    features: [
      'All our standard features',
      'Up to 500 projects',
      'Up to 15 users',
      'No everviz attribution',
      'Email support',
      'Custom branding',
    ],
  },
  {
    name: 'Enterprise',
    features: [
      'All our standard features',
      'Unlimited projects',
      'Unlimited users',
      'No everviz attribution',
      'First priority support',
      'Custom branding',
      'SLA',
    ],
  },
  {
    name: 'Storage',
    features: ['Storage of everviz projects', 'Upgrade to create new projects', 'Up to 15 users'],
  },
];
